function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletconnectreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial0",
    gradientUnits: "userSpaceOnUse",
    cx: 0,
    cy: 0.5,
    fx: 0,
    fy: 0.5,
    r: 1,
    gradientTransform: "matrix(32,0,0,32,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(36.470588%,61.568627%,96.470588%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0%,43.529412%,100%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "url(#radial0)"
    },
    d: "M 16 0 C 24.835938 0 32 7.164062 32 16 C 32 24.835938 24.835938 32 16 32 C 7.164062 32 0 24.835938 0 16 C 0 7.164062 7.164062 0 16 0 Z M 16 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.574219 11.53125 C 13.570312 8.601562 18.429688 8.601562 21.425781 11.53125 L 21.785156 11.886719 C 21.855469 11.957031 21.898438 12.050781 21.898438 12.152344 C 21.898438 12.25 21.855469 12.347656 21.785156 12.417969 L 20.550781 13.625 C 20.476562 13.699219 20.355469 13.699219 20.28125 13.625 L 19.785156 13.140625 C 17.695312 11.09375 14.304688 11.09375 12.214844 13.140625 L 11.683594 13.660156 C 11.609375 13.734375 11.488281 13.734375 11.414062 13.660156 L 10.179688 12.453125 C 10.109375 12.382812 10.066406 12.285156 10.066406 12.1875 C 10.066406 12.085938 10.109375 11.992188 10.179688 11.921875 Z M 23.976562 14.03125 L 25.074219 15.105469 C 25.144531 15.175781 25.183594 15.269531 25.183594 15.371094 C 25.183594 15.472656 25.144531 15.566406 25.074219 15.636719 L 20.125 20.484375 C 19.972656 20.628906 19.730469 20.628906 19.582031 20.484375 L 16.066406 17.042969 C 16.03125 17.007812 15.96875 17.007812 15.933594 17.042969 L 12.417969 20.484375 C 12.269531 20.628906 12.027344 20.628906 11.875 20.484375 L 6.925781 15.636719 C 6.855469 15.566406 6.816406 15.472656 6.816406 15.371094 C 6.816406 15.269531 6.855469 15.175781 6.925781 15.105469 L 8.023438 14.03125 C 8.175781 13.882812 8.417969 13.882812 8.566406 14.03125 L 12.082031 17.46875 C 12.117188 17.507812 12.179688 17.507812 12.214844 17.46875 L 15.730469 14.03125 C 15.878906 13.882812 16.121094 13.882812 16.269531 14.03125 L 19.785156 17.46875 C 19.820312 17.507812 19.882812 17.507812 19.917969 17.46875 L 23.433594 14.03125 C 23.582031 13.882812 23.824219 13.882812 23.976562 14.03125 Z M 23.976562 14.03125 "
  })));
}
export default SvgWalletconnectreact;